import { getServerSideTranslationProps } from '@/utils/translation'
import Layout from '@/components/Layout/Layout'
import SEO from '@/components/Layout/MetadataManager'
import PrivacyPolicy from '@/src/features/LegalPages/PrivacyPolicy/PrivacyPolicy'

const PrivacyPolicyPage = () => (
    <Layout>
        <SEO title="Privacy policy" description="Privacy policy page" fullTitle />
        <PrivacyPolicy />
    </Layout>
)

const i18nNamespaces = ['privacyPolicy']

export const getStaticProps = async ({ locale }) => ({
    props: {
        ...(await getServerSideTranslationProps({ locale: 'en', i18nNamespaces })),
    },
})

export default PrivacyPolicyPage
